export enum ApiRoutesStaff {
  StaffManager = "admin/moderator",
  AllStaffManagers = "admin/moderator/all",
  Admin = "admin",
  Restore = "restore"
}
